<template>

    <!--<div class="grid flex justify-content-center mt-5 p-3">
        <div class="col-10">
            <Breadcrumb :home="home" :model="items" />
        </div>
    </div>-->


    <div class="grid flex md:justify-content-center mt-2">
        <div class="md:col-10 sm:col-12 lg:col-10">
            <component :is="Component" @prev-page="prevPage($event)" @next-page="nextPage($event)" @CheckStatus ="CheckUserStatus" @complete="complete"  v-bind="Props"/>
        </div>
    </div>

    <p-toast></p-toast>
</template>

<style>
    .p-inputwrapper {
        width: 100% !important;
    }
</style>

<script>

    /* eslint-disable no-debugger */
   
    import Splitter from 'primevue/splitter';
    import SplitterPanel from 'primevue/splitterpanel';
    import Password from 'primevue/password';
 /*   import RadioButton from 'primevue/radiobutton';*/
    import Divider from 'primevue/divider';
    import Breadcrumb from 'primevue/breadcrumb';
    import Button from 'primevue/button';
    import Steps from 'primevue/steps';
    import { useToast } from "primevue/usetoast";
    import { ref } from 'vue';
    import { defineAsyncComponent } from 'vue'

    export default {
        name: 'SignUp',
        components: {
            Splitter,
            SplitterPanel,
            Password,
            /* RadioButton,*/
            Steps,
            ref,
            Divider,
            defineAsyncComponent,
            Breadcrumb,
            Button
        },
        data: () => ({
            checkbox: true,
            overlay: true,
            Tier: '',
            BtnText:'Subscribe',
            IsSigningUp:false,
            User: {
                FirstName: '',
                LastName: '',
                Email: '',
                Password: ''
            },
            Props: { SubscriberName: null },
            Component: '',
            Components: {
                Step1: defineAsyncComponent(() =>import('./SignUp/StepOne.vue')),
                Step2: defineAsyncComponent(() => import('./SignUp/StepTwo.vue')),
                Step3: defineAsyncComponent(() => import('./SignUp/StepThree.vue'))
            },
            CurrentwizardStep:0,
            formObject: {},
            home: { icon: 'pi pi-home', to: '/' },
            items: [
                { label: 'Choose Subscription' }
            ],
            StepperItems: ref([{
                label: 'Select your plan',
                to: '/SignUpStepOne'
            },
                {
                    label:'Create Your Account',
                    to:'/SignUpStepTwo'
                }
          ])
        }),
        setup() {
            const toast = useToast()
            return {toast}
        },
        created() {
          this.User.Email = this.$route.params.Email
          this.CheckUserStatus();
          this.$emit("set-nav", this.$route)
        },
       
        methods: {
            SignUpUser() {
                this.BtnText="Creating Account"
                this.IsSigningUp = true;
            },
            showSuccess() {
                this.$toast.add({ severity: 'success', summary: 'Success!', detail: 'Your Account Has Been Successfully Created' });
            },

          async CheckUserStatus() {
            var self = this;

            await this.$http.post('/Authorization/CheckUserStatus',
               {
                 UserName: this.$route.params.Email
               }).then(function (response) {
                 if (response.data.userExists) {
                   var user = response.data.user;
                   var userStatus = response.data.subscriptionStatusId;

                   /*if user has not subscribed but got past step one*/
                   if (userStatus == null) {
                     self.Props = { SubscriberName: user.firstName + " " + user.lastName, Email: user.userName, StripeCustomerId: user.stripeCustomerId }
                     self.Component = self.Components.Step2
                   }

                   /*If user has an account but is suspended redirect to step 3 to update payment info*/
                   if (userStatus == 3000) {
                     self.Props.SubscriberName = user.firstName + " " + user.lastName;
                     self.Component = self.Components.Step3
                   }

                   /*If user has an active account redirect to login and prefil username with email address*/
                   if (userStatus == 2000) {
                     debugger;

                     self.Component = self.Components.Step3
                   }

                   console.log(response.data.user)
                 }
                 else {
                   self.Component = self.Components.Step1;
                 }
               })
           },
            nextPage(event) {
                
                if (event.PageNumber === 2)
                this.Component = this.Components.Step2
                this.Props = event;

                if (event.PageNumber === 3)
                this.Component = this.Components.Step3
                this.Props = event
            },
            Home() {

                this.$router.push('/')
            },
            prevPage(event) {
              if (event.PageNumber === 2)
                this.Component = this.Components.Step2
                this.Props = event;

              if (event.PageNumber === 3)
                this.Component = this.Components.Step3
                this.Props = event
            },
            complete() {
                this.$toast.add({ severity: 'success', summary: 'Account Created S', detail: 'Dear, ' + this.formObject.firstname + ' ' + this.formObject.lastname + ' your order completed.' });
            }
        }

    }
</script>